import { useRef, useState, useEffect } from "react";
import styles from "../mainPage.module.css";
import { addCommas, removeCommas } from "@persian-tools/persian-tools";
import toast, { Toaster } from "react-hot-toast";

const TodoForm = (props) => {
  const [value, setValue] = useState("");
  const [value2, setValue2] = useState("");
  const [price, setPrice] = useState(0);
  const inputRef = useRef(null);

  useEffect(() => {
    inputRef.current.focus();
  }, []);

  const changeHandler = (e) => {
    setValue(e.target.value);
  };
  const changeHandler2 = (e) => {
    setValue2(e.target.value);
  };
  const changeHandlerPrice = (e) => {
    setPrice(removeCommas(e.target.value));
  };

  const submitHandler = (e) => {
    e.preventDefault();

    if (!value) {
      toast.error("لطفا تمامی فیلدها را پر کنید!");
      return;
    }
    if (!price) {
      toast.error("لطفا تمامی فیلدها را پر کنید!");
      return;
    }

    props.addTodoHandler(value, price, value2);
    setValue("");
    setPrice("");
    setValue2("");
  };

  return (
    <div>
      <form onSubmit={submitHandler} className={styles.formTodos}>
        <button type="submit" className={styles.inputBtn}>
          +
        </button>
        <input placeholder="توضیحات " type="text" onChange={changeHandler2} value={value2} ref={inputRef} className={styles.inputName} />

        <input type="text" onChange={changeHandlerPrice} value={addCommas(price)} ref={inputRef} className={styles.inputName} placeholder="قیمت " />

        <input placeholder="نام هزینه" type="text" onChange={changeHandler} value={value} ref={inputRef} className={styles.inputName} />
      </form>
    </div>
  );
};

export default TodoForm;
